export const ASK_QUESTION_FORM_STEP = 'askQuestionFormStep'
export const ASK_QUESTION_INFORMATION_STEP = 'askQuestionInformationStep'

export default ASK_QUESTION_FORM_STEP
